export default {
  songs: [],
  playList: [],
  blackist: [],
  artists: [],
  search: [],
  showHome: true,
  showPlaylist: false,
  showArtist: false,
  showFavourities: false,
  showBlacklist: false,
  showDeveloper: false,
  showSearch: false,
  otherSearch: false,
  openSortDiv: false,
  showPlaylistPropertise: false,
  showPlayingMusics: false,
  showPlayingSongPropertises: false,
  revealProperties: false,
  currentSong: {},
  current: null,
  songPropertise: null,
  index: 0,
  player: new Audio(),
  isPlaying: false,
  repeatSong: false,
  playRandomSong: false,
  loading: false,
  searcInput: "",
  sortByTitle: true,
  sortByDate: false,
  sortByArtist: false,
  sortByRandom: false,
  ascending: true,
  descending: false,
  activePage: "home",
  notificationMessage: "",
  showNotificationMessage: false,
};